class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onViewportChange = this.positionUnderCartIcon.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.onPageHide = () => this.close();
    this.onPageShow = (event) => {
      // 戻る操作の BFCache 復元時に、開いたままの通知が再表示されないようにする
      if (event.persisted) this.close();
    };
  }

  connectedCallback() {
    this.positionUnderCartIcon();
    window.addEventListener('pagehide', this.onPageHide);
    window.addEventListener('pageshow', this.onPageShow);
  }

  disconnectedCallback() {
    window.removeEventListener('pagehide', this.onPageHide);
    window.removeEventListener('pageshow', this.onPageShow);
  }

  positionUnderCartIcon() {
    if (!this.notification) return;

    const cartIcon = document.getElementById('cart-icon-bubble');
    const edge = 12;
    const gap = 8;
    const maxWidth = Math.min(368, window.innerWidth - edge * 2);

    let top;
    let right;

    if (cartIcon) {
      const rect = cartIcon.getBoundingClientRect();
      top = Math.max(edge, rect.bottom + gap);
      // パネル右端をカートアイコン右端に揃える（はみ出す場合はビューポート内に収める）
      right = window.innerWidth - rect.right;
      const maxRight = window.innerWidth - maxWidth - edge;
      right = Math.min(Math.max(edge, right), Math.max(edge, maxRight));
    } else {
      const header = document.querySelector('.section-header') || document.querySelector('sticky-header');
      top = (header?.getBoundingClientRect().bottom || 64) + gap;
      right = edge;
    }

    this.notification.style.setProperty('--cart-notification-top', `${top}px`);
    this.notification.style.setProperty('--cart-notification-right', `${right}px`);
    this.notification.style.setProperty('--cart-notification-width', `${maxWidth}px`);
  }

  open() {
    this.positionUnderCartIcon();
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    window.addEventListener('resize', this.onViewportChange);
    window.addEventListener('scroll', this.onViewportChange, { passive: true });
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    window.removeEventListener('resize', this.onViewportChange);
    window.removeEventListener('scroll', this.onViewportChange);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) return;

      const sectionHtml = parsedState.sections?.[section.id];
      if (!sectionHtml) return;

      try {
        const html = this.getSectionInnerHTML(sectionHtml, section.selector);
        if (html != null) sectionElement.innerHTML = html;
      } catch (error) {
        console.error('[cart-notification] section render failed', section.id, error);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const root = new DOMParser().parseFromString(html, 'text/html');
    const element = root.querySelector(selector) || root.querySelector('.shopify-section') || root.body;
    return element ? element.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
